import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLastPrepaid, selectIsFailureLast, selectIsFetchingLast, selectIsLoadedLast, selectIsToRefetchLast, selectPrepaidForCurrent } from '../../../modules/prepaid';
export function usePrepaid({
  sharingId
}) {
  const dispatch = useDispatch();
  const prepaid = useSelector(selectPrepaidForCurrent);
  const isLoading = useSelector(state => selectIsFetchingLast(state, {
    sharingId
  }));
  const isFailure = useSelector(state => selectIsFailureLast(state, {
    sharingId
  }));
  const isToRefetch = useSelector(state => selectIsToRefetchLast(state, {
    sharingId
  }));
  const isLoaded = useSelector(state => selectIsLoadedLast(state, {
    sharingId
  }));
  const amount = prepaid?.amount;
  const shouldFetch = Number.isNaN(amount) && (!isLoaded || isToRefetch) && !(isLoading || isFailure);
  React.useEffect(() => {
    if (shouldFetch) {
      dispatch(fetchLastPrepaid(sharingId));
    }
  }, [dispatch, sharingId, shouldFetch]);
  return prepaid;
}